import { deadlineCountdown, formatDateRange } from '../lib/dates.js';
import { formatDistance } from '../lib/geo.js';

const FORMAT_LABELS = {
  'in-person': 'In-person',
  hybrid: 'Hybrid',
  online: 'Online',
};

export default function HackathonCard({ hackathon }) {
  const countdown = deadlineCountdown(hackathon.registration_deadline);
  const distance = formatDistance(hackathon.distance_mi);
  const place = [hackathon.venue_city, hackathon.venue_state, hackathon.venue_country]
    .filter(Boolean)
    .join(', ');

  return (
    <article className="card">
      <header className="card-header">
        <span className={`badge badge-${hackathon.format}`}>
          {FORMAT_LABELS[hackathon.format] || hackathon.format}
        </span>
        {countdown ? (
          <span className={`countdown countdown-${countdown.urgency}`}>{countdown.text}</span>
        ) : null}
      </header>

      <h2 className="card-title">
        <a href={hackathon.source_url} target="_blank" rel="noopener noreferrer">
          {hackathon.name}
        </a>
      </h2>

      <dl className="card-facts">
        <div className="fact">
          <dt>Dates</dt>
          <dd>{formatDateRange(hackathon.start_date, hackathon.end_date)}</dd>
        </div>

        {hackathon.format !== 'online' ? (
          <div className="fact">
            <dt>Where</dt>
            <dd>
              {place || 'Location TBA'}
              {distance ? <span className="fact-distance"> · {distance} away</span> : null}
            </dd>
          </div>
        ) : null}

        {hackathon.prize_summary ? (
          <div className="fact">
            <dt>Prizes</dt>
            <dd>{hackathon.prize_summary}</dd>
          </div>
        ) : null}
      </dl>

      {hackathon.themes && hackathon.themes.length > 0 ? (
        <ul className="card-themes">
          {hackathon.themes.slice(0, 4).map((theme) => (
            <li key={theme}>{theme}</li>
          ))}
        </ul>
      ) : null}

      <footer className="card-footer">
        {/* Every link goes back to the original listing — we never mirror registration. */}
        {(hackathon.sources || [{ platform: hackathon.source_platform, url: hackathon.source_url }]).map(
          (source) => (
            <a
              key={source.url}
              className="source-link"
              href={source.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {source.platform}
              <span aria-hidden="true"> ↗</span>
            </a>
          ),
        )}
      </footer>
    </article>
  );
}
